import { useParams, Link } from 'react-router-dom';
import { categories, getCategoryBySlug } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = getCategoryBySlug(slug || '');
  const articles = category ? getArticlesByCategory(category.id) : [];

  if (!category) {
    return (
      <main className="min-h-screen pt-20">
        <div className="w-full px-4 md:px-6 max-w-7xl mx-auto py-20 text-center">
          <h1 className="font-heading text-2xl font-bold text-foreground-900">分类不存在</h1>
          <Link to="/" className="mt-4 inline-block text-primary-500 hover:text-primary-600 cursor-pointer">
            返回首页
          </Link>
        </div>
      </main>
    );
  }

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${category.name} - 火影同人指南`,
    description: category.description,
    inLanguage: 'zh-CN',
  };

  return (
    <main className="min-h-screen pt-24">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageSchema) }}
      />
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: category.name },
            ]}
          />
        </div>

        <div className="mb-10">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500">
              <i className={`${category.icon} text-lg`}></i>
            </div>
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              {category.name}
            </h1>
          </div>
          <p className="text-sm text-foreground-500 ml-13">{category.description}</p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8">
          <aside className="w-full lg:w-56 flex-shrink-0">
            <div className="lg:sticky lg:top-24">
              <h4 className="font-heading font-semibold text-foreground-900 mb-3 text-sm">
                全部分类
              </h4>
              <nav className="space-y-1">
                {categories.map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className={`block px-3 py-2 rounded-lg text-sm transition-colors cursor-pointer whitespace-nowrap ${
                      cat.id === category.id
                        ? 'bg-primary-50 text-primary-600 font-medium'
                        : 'text-foreground-600 hover:bg-background-100'
                    }`}
                  >
                    {cat.name}
                    <span className="text-xs text-foreground-400 ml-2">({cat.articleCount})</span>
                  </Link>
                ))}
              </nav>
            </div>
          </aside>

          <div className="flex-1 min-w-0">
            {articles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                {articles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <p className="text-foreground-500">暂无文章</p>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="h-16"></div>
    </main>
  );
}